(() => {
  document.querySelectorAll('[data-launch-offer]').forEach(offer => {
    const timer = offer.querySelector('[role="timer"]');
    const end = Date.parse(offer.dataset.end);
    function update() {
      const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!remaining) {
        offer.hidden = true;
        clearInterval(interval);
        return;
      }
      const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
      Object.entries(values).forEach(([key, value]) => { timer.querySelector(`[data-unit="${key}"]`).textContent = String(value).padStart(2, '0'); });
      timer.hidden = false;
    }
    const interval = setInterval(update, 1000);
    update();
  });
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  if (preview) {
    document.querySelectorAll('.wl-portfolio a, .wl-concept a, .wl-pro-mood a').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin) { url.searchParams.set('preview_theme_id', preview); link.href = url.href; }
    });
  }
})();
